import { ca } from '@cian/analytics';
import { IProduct } from '../../types/analytics/products';

export function trackAgentFlatsLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_agentsFlats',
    label: 'all',
    useLastProducts: true,
  });
}

export function trackAllFlatsLinkClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_allFlats',
    label: 'all',
    useLastProducts: true,
  });
}

export function trackRoomTypeLinkClick(label: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'click_developersFlats',
    label,
    useLastProducts: true,
  });
}

export function trackOffersQuantityLinkClick(product: IProduct, roomType: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'Click',
    label: 'Flats',
    products: [{ ...product, extra: { room_num: roomType } }],
  });
}

export function trackOpenFlat(offerId: number, gaLabel: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Card_JK',
    action: 'open_flat',
    label: gaLabel,
    page: {
      dealType: 'sale',
      objectType: 'flat',
      offerID: offerId,
      pageType: 'CardJK',
      siteType: 'desktop',
      extra: {
        PageTypeJK: 'Featuring',
      },
    },
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position: 1,
      },
    ],
    modelVersion: '1',
  });
}
